import formEmbeddableMixin from "@/mixins/embeddable/resource/formEmbeddableMixin";
import QuoteFormEmbeddable from "@/views/modules/business/Quote/embeddable/QuoteFormEmbeddable";
import QuoteEntity from "@/model/entities/modules/business/QuoteEntity";

export default {
    components: {QuoteFormEmbeddable},
    mixins: [formEmbeddableMixin],
    data() {
        return {
            path: "business/quote",
            form: new QuoteEntity()
        }

    },
    methods: {


    }
}